import { IdentificationCard, IdentificationCardLabel } from '@idc-forms/types/identifications'

export { IdentificationCard, IdentificationCardLabel }

// FE-only: arrays para <select>
export const CATALOG_TYPE_IDENTIFICATION_CARD = [
  { value: IdentificationCard.DPI, label: IdentificationCardLabel[IdentificationCard.DPI] },
  {
    value: IdentificationCard.PASSPORT,
    label: IdentificationCardLabel[IdentificationCard.PASSPORT]
  }
]

export const CATALOG_TYPE_IDENTIFICATION_BENEFICIARIES = [
  { value: IdentificationCard.DPI, label: IdentificationCardLabel[IdentificationCard.DPI] },
  {
    value: IdentificationCard.DPI_FOREIGN_DOMICILED,
    label: IdentificationCardLabel[IdentificationCard.DPI_FOREIGN_DOMICILED]
  },
  {
    value: IdentificationCard.PASSPORT,
    label: IdentificationCardLabel[IdentificationCard.PASSPORT]
  },
  {
    value: IdentificationCard.BIRTH_CERTIFICATE,
    label: IdentificationCardLabel[IdentificationCard.BIRTH_CERTIFICATE]
  }
]

// FE-only: masks e input placeholders
export const MASK_IDENTIFICATION_CARD_SCHEMA = {
  D: '0000 00000 0000',
  DFD: '0000 00000 0000',
  P: '',
  CN: '0000 00000 0000',
  DF: ''
} as const

/**
 * Máscara del campo «número de documento» según el tipo elegido.
 *
 * El **pasaporte no tiene formato fijo**, así que va sin máscara — y en imask «sin máscara» se
 * expresa con el constructor `String`, no con `''` ni `undefined`: con esos dos el campo no deja
 * escribir, que fue un bug de producción (PR #62).
 *
 * **El tipo declarado es `string` y el valor en runtime puede no serlo.** Es deliberado y ésta es
 * la razón: `IMaskInputProps` es una unión DISCRIMINADA —una rama por tipo de máscara— así que un
 * valor cuyo TIPO varíe entre ramas (`string` para DPI, `StringConstructor` para pasaporte) no
 * satisface ninguna, y TypeScript lo rechaza en el punto de uso sin importar cómo se declare.
 *
 * Se ancla a la rama de patrón (`string`), que es la que usan los otros tipos de documento, y la
 * brecha queda en UNA función explicada en vez de repartida en cuatro formularios. Si `react-imask`
 * modela algún día «sin máscara» en la misma rama, esto se borra y el cast se va con él.
 */
export const maskForIdentification = (type: keyof typeof MASK_IDENTIFICATION_CARD_SCHEMA): string =>
  (type === 'P' ? String : MASK_IDENTIFICATION_CARD_SCHEMA[type]) as unknown as string

export const PLACEHOLDER_IDENTIFICATION_CARD_SCHEMA = {
  D: '____ _____ ____',
  DFD: '____ _____ ____',
  P: '',
  CN: '____ _____ ____',
  DF: ''
} as const

// Aliases temporales con keys del enum viejo — borrar cuando se actualicen los consumers
// El enum viejo tenía keys = values: { D: 'D', DFD: 'DFD', P: 'P', CN: 'CN', DF: 'DF' }
// El objeto nuevo usa keys descriptivos: { DPI: 'D', PASSPORT: 'P', ... }
export const EnumIdentificationCard = {
  ...IdentificationCard,
  D: IdentificationCard.DPI,
  DFD: IdentificationCard.DPI_FOREIGN_DOMICILED,
  P: IdentificationCard.PASSPORT,
  CN: IdentificationCard.BIRTH_CERTIFICATE,
  DF: IdentificationCard.GENERIC
} as const

export type EnumIdentificationCard = IdentificationCard

export const TYPE_IDENTIFICATION_CARD = {
  ...IdentificationCard,
  D: IdentificationCard.DPI,
  DFD: IdentificationCard.DPI_FOREIGN_DOMICILED,
  P: IdentificationCard.PASSPORT,
  CN: IdentificationCard.BIRTH_CERTIFICATE,
  DF: IdentificationCard.GENERIC
} as const

export const NAME_IDENTIFICATION_CARD = IdentificationCardLabel as Record<
  IdentificationCard,
  string
>
export type TypesIdentificationCard = IdentificationCard
